import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FacebookService, InitParams } from 'ngx-facebook';

@Injectable({
    providedIn: 'root'
})
export class UserFacebookService
{
    constructor(private http: HttpClient, private fb: FacebookService)
    {
        const initParams: InitParams = 
        {
            appId: "1396443771147844",
            xfbml: true,
            version: "v17.0"
        }
        fb.init(initParams);
    }

    public getPageAccessToken(userId: string, userAccessToken: string): Observable<any>
    {
        return this.http.get<any>(`https://graph.facebook.com/${userId}/accounts?access_token=${userAccessToken}`);
    }

    public postToPage(): Observable<any>
    {
        return;
    }
}